"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkId = exports.LocationAreaCode = exports.SystemId = exports.CellId = void 0;
const effect_1 = require("effect");
const binary_1 = require("../../binary");
const NAMESPACE = 'Network.Cellular.Cdma';
exports.CellId = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.CellId`,
});
exports.SystemId = binary_1.Int16.pipe(effect_1.Schema.nonNegative()).annotations({
    identifier: `${NAMESPACE}.SystemId`,
});
exports.LocationAreaCode = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.LocationAreaCode`,
});
exports.NetworkId = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.NetworkId`,
});
//# sourceMappingURL=cdma.js.map